/**
 * Copyright 2023, IntraLinks, Inc. All rights reserved.
 */

export enum ENV {
  Development = 'development',
  Integration = 'integration',
  Staging = 'staging',
  Future = 'future',
  Preview = 'preview',
  Production = 'production',
  Test = 'test'
}